'use strict'

const { READ } = require('./readWriteModes')

module.exports = {
  collectionName: null,
  readWriteType: READ,
  filter: null,
  sort: null,
  includes: null,
  pageSize: 20
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/dataset-configuration/defaults.js